<template>
  <div class="wrapper">
    <ul class="list">
      <li
        v-for="currentCampaign in filteredCampaigns"
        :key="currentCampaign.id"
        class="item"
        :class="{
          selected: selectCampaign && selectCampaign.id === currentCampaign.id,
        }"
        @click="handleSelectedCampaign(currentCampaign)"
      >
        <div class="item-text">
          <!-- <fluent-icon icon="flash " size="16"/> -->
          {{ currentCampaign.title }}
        </div>
        <div class="item-actions">
          <fluent-icon
            class="edit-icon"
            icon="edit"
            size="16"
            @click.native.stop="openEditAppModal(currentCampaign)"
          />
          <fluent-icon
            class="delete-icon"
            icon="delete"
            size="16"
            @click.native.stop="openDeletePopup(currentCampaign)"
          />
        </div>
      </li>
    </ul>
    <DashboardAppModal
      :show="showDashboardAppModal"
      modal-origin="frameFull"
      :mode="dashboardAppModalMode"
      :selected-app-data="selectedAppData"
      @close="closeDashboardAppModal"
    />
    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('INTEGRATION_SETTINGS.DASHBOARD_APPS.DELETE.TITLE')"
      :message="
        $t('INTEGRATION_SETTINGS.DASHBOARD_APPS.DELETE.MESSAGE', {
          appName: selectedApp.title,
        })
      "
      :confirm-text="
        $t('INTEGRATION_SETTINGS.DASHBOARD_APPS.DELETE.CONFIRM_YES')
      "
      :reject-text="$t('INTEGRATION_SETTINGS.DASHBOARD_APPS.DELETE.CONFIRM_NO')"
    />
    <div class="create-app-link" @click="openCreateAppModal">
      <fluent-icon icon="add" size="16" />
      <span class="create-app-link-text">{{
        $t('SIDEBAR.NEW_DASHBOARD_APP')
      }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardAppModal from '../../settings/integrations/DashboardApps/DashboardAppModal.vue';

export default {
  name: 'DashboardEmbedSidebar',
  components: { DashboardAppModal },
  data() {
    return {
      selectCampaign: null,
      searchQuery: '',
      showDashboardAppModal: false,
      dashboardAppModalMode: 'CREATE',
      selectedAppData: null,
      showDeleteConfirmationPopup: false,
      selectedApp: {},
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      listCampaigns: 'campaignsFlow/getCampaigns',
      dashboardEmbed: 'dashboardApps/getRecords',
    }),
    filteredCampaigns() {
      const records = Array.isArray(this.dashboardEmbed)
        ? this.dashboardEmbed
        : [];
      const onlyFrameFull = records.filter(item => {
        const contents = Array.isArray(item.content) ? item.content : [];
        return contents.some(c => c && c.type === 'frameFull');
      });
      return onlyFrameFull;
    },
  },
  methods: {
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },

    handleSelectedCampaign(campaign) {
      this.selectCampaign = campaign;
      const contents = Array.isArray(campaign.content) ? campaign.content : [];
      const page = contents.find(c => c && c.type === 'frameFull');
      const url = page && page.url ? page.url : null;
      if (url) {
        this.$store.dispatch('dashboardApps/setSelectedUrl', url);
      }
    },

    openCreateAppModal() {
      this.dashboardAppModalMode = 'CREATE';
      this.selectedAppData = null;
      this.showDashboardAppModal = true;
    },

    openEditAppModal(appData) {
      this.dashboardAppModalMode = 'UPDATE';
      this.selectedAppData = appData;
      this.showDashboardAppModal = true;
    },

    openDeletePopup(app) {
      this.showDeleteConfirmationPopup = true;
      this.selectedApp = app || {};
    },

    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },

    confirmDeletion() {
      this.closeDeletePopup();
      if (this.selectedApp && this.selectedApp.id) {
        this.deleteApp(this.selectedApp.id);
      }
    },

    async deleteApp(id) {
      try {
        await this.$store.dispatch('dashboardApps/delete', id);
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.DASHBOARD_APPS.DELETE.API_SUCCESS')
        );
      } catch (error) {
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.DASHBOARD_APPS.DELETE.API_ERROR')
        );
      }
    },

    closeDashboardAppModal() {
      this.showDashboardAppModal = false;
      this.selectedAppData = null;
    },
  },
};
</script>

<style scoped>
.wrapper {
  padding: 8px;
}

.title {
  color: var(--s-700);
  display: flex;
  font-weight: var(--font-weight-bold);
  line-height: var(--space-normal);
  margin: var(--space-small) 0;
  padding: 0 var(--space-small);
  font-size: var(--font-size-small);
}

input {
  margin: 0 0 0 8px;
  height: 3rem;
  width: calc(100% - 16px);
  padding: 8px;
  border: 1px solid var(--s-400);
  border-radius: 4px;
}

.create-app-link-text {
  padding-top: 2px;
}

.create-app-link {
  margin: 8px;
  margin-top: 16px;
  color: var(--s-700);
  font-weight: 500;
  align-items: center;
  display: flex;
  font-size: small;
  cursor: pointer;
}
.create-app-link:hover {
  color: var(--w-700);
}

.item-text {
  flex: 1 1 auto;
  min-width: 0;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  word-break: break-word;

  color: var(--s-600);
  font-weight: var(--font-weight-medium);
  padding: var(--space-smaller) var(--space-smaller);
  margin: var(--space-smaller) 0;
  text-align: left;
  line-height: 1.6;
  font-size: 14px;
  gap: 0.3rem;
}
.item-text:hover {
  color: var(--g-20);
}

.item {
  cursor: pointer;
  margin: 5px 12px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Evita que conteúdo interno transborde para fora do item */
  overflow: hidden;
}

.item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item .edit-icon {
  visibility: hidden;
  color: var(--s-500);
}

.item .delete-icon {
  visibility: hidden;
  color: var(--s-500);
}

.item:hover .edit-icon {
  visibility: visible;
  /* era --w-700 (#135899 navy) → ilegível no dark. Cyan da marca (legível nos
     dois temas); excluir em vermelho para melhor affordance. US-4328 */
  color: var(--color-woot-darker);
}

.item:hover .delete-icon {
  visibility: visible;
  color: var(--r-500);
}

.item.selected {
  /* era --w-25 (#F5FAFF) fixo → item selecionado branco no dark.
     Tinta cyan do tema funciona nos dois. US-4328 */
  background-color: var(--color-woot-tint);
  border-radius: 8px;
}

.item.selected .item-text {
  color: var(--g-20);
  background-color: black;
  background: fixed;
}
</style>
